module.exports = __webpack_public_path__ + "img/199.95ac2ae3.jpg";